import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { createContext } from "react";

const ApplicationManagerContext = createContext();

export const ApplicationManagerContextProvider = ({ children }) => {
  const [applications, setApplications] = useState([]);
  const [applicationsLoading, setApplicationsLoading] = useState(true);
  const [activeApplicationId, setActiveApplicationId] = useState();
  const [applicationsRefreshTime, setApplicationsRefreshTime] = useState(
    new Date()
  );

  const [accountApplications, setAccountApplications] = useState([]);
  const [activeAccountApplicationId, setActiveAccountApplicationId] = useState();
  const [accountApplicationsRefreshTime, setAccountApplicationsRefreshTime] = useState(
    new Date()
  );

  const refreshAccountApplications = () => {
    setAccountApplicationsRefreshTime(new Date());
  };

  useEffect(() => {
    axios.get("/api/app/account-applications").then(({ data }) => {
      setAccountApplications(data.items);
    });
  }, [accountApplicationsRefreshTime]);

  const installAccountApplication = ({ applicationId, tier }) => {
    return axios.post("/api/app/account-applications/install", {
      applicationId,
      tier,
    });
  };
  const uninstallAccountApplication = ({ applicationId, tier }) => {
    return axios.post("/api/app/account-applications/uninstall", {
      applicationId,
      tier,
    });
  };
  const getAccountApplication = (accountApplicationId) => {
    return axios.get("/api/app/account-applications/" + accountApplicationId);
  };
  const getAccountApplicationByShortCode = (shortCode) => {
    return axios.get("/api/app/account-applications/by-short-code/" + shortCode);
  };
  const getAccountApplications = () => {
    return axios.get("/api/app/account-applications");
  };

  const refreshApplications = () => {
    setApplicationsRefreshTime(new Date());
  };

  useEffect(() => {
    setApplicationsLoading(true);
    axios.get("/api/app/applications").then(({ data }) => {
      setApplications(data);
    }).finally(() => {
      setApplicationsLoading(false);
    });
  }, [applicationsRefreshTime]);

  const installApplication = ({ applicationId, tier, consentText, consentChecked, source, consentVersion }) => {
    return axios.post("/api/app/applications/install", {
      applicationId,
      tier,
      consentText,
      consentChecked,
      source,
      consentVersion,
    });
  };
  const uninstallApplication = ({ applicationId, tier }) => {
    return axios.post("/api/app/applications/uninstall", {
      applicationId,
      tier,
    });
  };
  const getApplication = (applicationId) => {
    return axios.get("/api/app/applications/" + applicationId);
  };
  const getApplicationByShortCode = (shortCode) => {
    return axios.get("/api/app/applications/by-short-code/" + shortCode);
  };
  const getInstalledApplications = () => {
    return axios.get("/api/app/applications/installed");
  };
  const getInstalledAccountApplications = () => {
    return axios.get("/api/app/account-applications/installed");
  }
  const getApplicationResources = (applicationId) => {
    return axios.get("/api/app/applications/" + applicationId + "/resources");
  }
  const createAccountApplication = (application) => {
    return axios.post("/api/app/account-applications", application);
  }

  const updateAccountApplication = (application) => {
    return axios.put("/api/app/account-applications/" + application.id, application);
  }

  const getApplicationScopeStatus = (applicationId) => {
    return axios.get("/api/app/applications/" + applicationId + "/scope-status");
  }
  const approveApplicationScopes = (applicationId, scopes) => {
    return axios.post("/api/app/applications/" + applicationId + "/approve-scopes", { scopes });
  }
  const getAccountApplicationScopeStatus = (applicationId) => {
    return axios.get("/api/app/account-applications/" + applicationId + "/scope-status");
  }
  const approveAccountApplicationScopes = (applicationId, scopes) => {
    return axios.post("/api/app/account-applications/" + applicationId + "/approve-scopes", { scopes });
  }
  const getInstalledScopeStatuses = () => {
    return axios.get("/api/app/installed-applications/scope-status");
  }
  const reconnectApplication = (applicationId) => {
    return axios.post("/api/app/applications/" + applicationId + "/reconnect");
  }
  const reconnectAccountApplication = (applicationId) => {
    return axios.post("/api/app/account-applications/" + applicationId + "/reconnect");
  }

  return (
    <ApplicationManagerContext.Provider
      value={{
        applications,
        applicationsLoading,
        refreshApplications,
        installApplication,
        uninstallApplication,
        activeApplicationId,
        setActiveApplicationId,
        getApplication,
        getApplicationByShortCode,

        accountApplications,
        refreshAccountApplications,
        installAccountApplication,
        uninstallAccountApplication,
        activeAccountApplicationId,
        setActiveAccountApplicationId,
        getAccountApplication,
        getAccountApplicationByShortCode,
        getAccountApplications,

        getInstalledApplications,
        getInstalledAccountApplications,
        getApplicationResources,
        createAccountApplication,
        updateAccountApplication,

        getApplicationScopeStatus,
        approveApplicationScopes,
        getAccountApplicationScopeStatus,
        approveAccountApplicationScopes,
        getInstalledScopeStatuses,
        reconnectApplication,
        reconnectAccountApplication
      }}
    >
      {children}
    </ApplicationManagerContext.Provider>
  );
};

export default ApplicationManagerContext;
